import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {RTL_LANGUAGES} from "./index";

// Keeps <html lang="..."> and <html dir="..."> in sync with the active
// i18next language. Mount this once near the app root.
//
// Note: this only flips text direction / the `lang` attribute. It does NOT
// mirror the layout — the app's CSS still uses physical Tailwind utilities
// (pl-/pr-/ml-/mr-/left-/right-) almost everywhere, so Arabic will read
// right-to-left but the surrounding layout stays LTR until that's migrated
// to logical properties (see the i18n rollout plan, phase 4).
export const useHtmlLangDir = () => {
    const {i18n} = useTranslation();

    useEffect(() => {
        const applyLangDir = (lng) => {
            const dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
            document.documentElement.lang = lng;
            document.documentElement.dir = dir;
        };

        applyLangDir(i18n.language);
        i18n.on("languageChanged", applyLangDir);
        return () => i18n.off("languageChanged", applyLangDir);
    }, [i18n]);
};
